<template>
    <div>
        <div class="form__group">
            <label class="form__label  form__label--block">{{ getTranslation('state') }} <span v-if="required" class="required">*</span> </label>
            <v-select
                    ref="localStateSelect"
                    v-model="stateId"
                    :options="states"
                    :reduce="option=>option.id"
                    @search:blur="!stateId ? customValidator.stateId = false : customValidator.stateId = true"
                    :class="{ 'field--error': !customValidator.stateId }"
                    :placeholder="getTranslation('selectFromList')"
                    label="name"
            />
            <div v-if="required && !customValidator.stateId" class="form__error">{{ getTranslation('requiredField') }}</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "LocalStateSelect",
        data() {
            return {
                states: [],
                stateId: '',
                timer: null,
                showSelect: false,
                customValidator: {
                    stateId: true,
                }
            }
        },
        props: ['editStateId', 'required'],
        watch: {
            'stateId'( id ) {
                this.$emit( 'input', id );
                if ( !id ) {
                    this.fetchStates();
                }
            }
        },
        created() {
            this.fetchStates().then( () => {
                if ( this.editStateId )
                    this.stateId = this.editStateId;
            } );
        },
        mounted() {
            let searchInput = this.$refs.localStateSelect.$el.getElementsByClassName( 'vs__search' ),
                searchText = '';
            if ( searchInput.length > 0 ) searchInput[0].oninput = e => {
                if ( this.timer ) clearTimeout( this.timer );
                if ( searchText !== e.target.value ) {
                    this.timer = setTimeout( () => {
                        searchText = e.target.value;
                        this.searchState( searchText );
                        this.timer = null;
                    }, 500 );
                }
            };
        },
        methods: {
            fetchStates() {
                return this.axios.get( this.$config.urls.state.fetchStates.url )
                           .then( response => {
                               this.states = response.data.data.items;
                           } )
            },
            searchState( searchText ) {
                let params = {};
                if ( searchText ) params.query = searchText;
                return this.axios.get( this.$config.urls.state.fetchStates.url, { params: params } )
                           .then( response => {
                               this.states = response.data.data.items;
                           } )
            },
            
            // We will call this method from parent component for check validity
            checkValidity() {
                if ( !this.stateId ) {
                    this.customValidator.stateId = false;
                    return false;
                }
                
                return true;
            }
        }
    }
</script>

<style scoped>

</style>